import { LoadingOutlined } from "@ant-design/icons";
import { DatePicker } from "antd";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import React from "react";
import { FormDatePickerProps } from "./IFormComponents";

const FormDatePicker = ({
  label,
  field,
  value,
  onChangeInvestor,
  index,
  arrayField,
  mandatory = false,
  disabled = false,
  placeholder = "Seleccione una fecha",
  error,
  isOcrLoading = false,
  translations
}: FormDatePickerProps) => {
  const handleChange = (date: Dayjs | null) => {
    if (typeof onChangeInvestor === "function") {
      onChangeInvestor(
        dayjs(date).format("YYYY-MM-DD"),
        field,
        index,
        arrayField
      );
    }
  };

  return (
    <div className="investor-form-item">
      <label
        className={`${mandatory ? "mandatory" : ""} ${
          error ? "error-input" : ""
        } `}
      >
        {label}
      </label>
      <DatePicker
        value={value ? dayjs(value, "YYYY-MM-DD") : null}
        onChange={handleChange}
        style={{ width: "100%" }}
        placeholder={isOcrLoading ? translations?.readingDocument : placeholder}
        suffixIcon={isOcrLoading ? <LoadingOutlined spin /> : null}
        disabled={disabled || isOcrLoading}
        format="DD/MM/YYYY"
        status={error ? "error" : undefined}
      />
    </div>
  );
};

export default FormDatePicker;
